import AnimeThemeSelector from '../fields/AnimeThemeSelector';
import CustomPhotoUpload from '../fields/CustomPhotoUpload';
import CustomThemeSelector from '../fields/CustomThemeSelector';
import DefaultThemeSelector from '../fields/DefaultThemeSelector';

const ThemeSettings: React.FC = () => (
    <div>
        <h3 className="text-lg font-semibold">Theme</h3>
        <div className="mt-6 space-y-6">
            <DefaultThemeSelector />
            <AnimeThemeSelector />
            <CustomPhotoUpload />
            <CustomThemeSelector />
        </div>
    </div>
);

export default ThemeSettings;
